module.exports = __webpack_public_path__ + "static/media/960w.78994f30.jpg";